import React from "react";
import { useSync } from "@/context/SyncContext";
import { Cloud, CloudOff, RefreshCw, CheckCircle2 } from "lucide-react";

export function SyncBadge() {
  const { online, pending, syncing } = useSync();

  let icon, text, cls;
  if (!online) {
    icon = <CloudOff size={15} />;
    text = "Hors ligne";
    cls = "bg-amber-100 text-amber-800";
  } else if (syncing || pending > 0) {
    icon = <RefreshCw size={15} className={syncing ? "animate-spin" : ""} />;
    text = pending > 0 ? `${pending} en attente` : "Sync…";
    cls = "bg-amber-100 text-amber-800";
  } else {
    icon = <CheckCircle2 size={15} />;
    text = "Synchronisé";
    cls = "bg-white/15 text-white";
  }

  return (
    <div
      data-testid="sync-badge"
      className={`flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${cls}`}
    >
      {icon}
      <span>{text}</span>
    </div>
  );
}
